// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"742f3f50","455":"3e842287"}[chunkId] + ".chunk.js";
};